/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'

export default {
  fetchAll ({commit}, {programId} = {}) {
    return new Promise((resolve, reject) => {
      if (programId) {
        axios.get('/resources/programs', {
          params: {
            program_id: programId
          }
        })
          .then((res) => {
            commit('SET', res.data)
            resolve(res.data)
          })
          .catch((e) => {
            reject(e)
          })
      } else {
        axios.get('/resources/programs')
          .then((res) => {
            commit('SET', res.data)
            resolve(res.data)
          })
          .catch((e) => {
            reject(e)
          })
      }
    })
  }
}
